const MINUTES_PER_HOUR = 60;
const MINUTES_PER_DAY = 1440;

/**
 * Formats a duration in minutes to a human-friendly string (e.g. "45 min", "1 h 30 min", "2 d 5 h").
 * Reusable across the app (confirmations history, reports, etc.).
 *
 * @param minutes - Duration in minutes (non-negative integer or 0)
 * @returns e.g. "45 min", "1 h", "1 h 15 min", "2 d 6 h 15 min"
 */
export function formatDurationMinutes(minutes: number): string {
  if (minutes == null || Number.isNaN(minutes) || minutes < 0) return "";
  const total = Math.floor(minutes);

  if (total < MINUTES_PER_HOUR) {
    return total === 0 ? "0 min" : `${total} min`;
  }

  if (total < MINUTES_PER_DAY) {
    const h = Math.floor(total / MINUTES_PER_HOUR);
    const m = total % MINUTES_PER_HOUR;
    return m > 0 ? `${h} h ${m} min` : `${h} h`;
  }

  const d = Math.floor(total / MINUTES_PER_DAY);
  const remainder = total % MINUTES_PER_DAY;
  const h = Math.floor(remainder / MINUTES_PER_HOUR);
  const m = remainder % MINUTES_PER_HOUR;

  const parts: string[] = [`${d} d`];
  if (h > 0) parts.push(`${h} h`);
  if (m > 0) parts.push(`${m} min`);
  return parts.join(" ");
}
